<!-- eslint-disable -->
<template>
  <div class="collapse navbar-collapse nav-wrapper" id="navigation">
    <ul class="navbar-nav mr-auto slimmenu navbar-left" id="navigations">

      <template v-for="(pin, i) in tenant.metadata.menu">
        <menu-list-item v-if="hasSkinPermission(pin)" :key="i" :item="pin">
          <menu-item :item="pin" :iframe="iframe" />

          <div v-if="pin.children && pin.children.length" class="dropdown-menu " :class="`dropdown-menu-${pin.dropDownMenuPosition ? pin.dropDownMenuPosition: 'right'}`" aria-labelledby="navbarDropdown">
            <template v-for="child in pin.children">
              <template v-if="hasSkinPermission(child)">
                <template v-if="typeof child === 'object'">
                  <template v-if="child.routeType === 'heading'">
                    <a class="dropdown-item"><span class="text-muted">{{child.display}}</span></a>
                  </template>
                  <template v-else-if="child.routeType === 'divider'">
                    <div class="dropdown-divider"></div>
                  </template>
                  <template v-else>
                    <menu-item :border="false" :item="child" :iframe="iframe" class="dropdown-item" />
                  </template>
                </template>
                <template v-else-if="typeof child === 'string' && child !== 'divider'">
                  <a class="dropdown-item"><span class="text-muted">{{child}}</span></a>
                </template>
                <template v-else>
                  <div class="dropdown-divider"></div>
                </template>
              </template>
            </template>
          </div>
        </menu-list-item>
      </template>

    </ul>
    <ul class="navbar-nav ml-auto slimmenu navbar-right">
      <li id="catalog-currency-selector" class="nav-item d-none"></li>

      <template>

        <li class="nav-item pr-0" v-if="showMessagingCenter">
          <a @click.prevent="onMessagingCenter" class="nav-item-cart d-flex align-items-center" href="#">
            <i v-if="$bus.messagingCenter.loading" class="fas fa-circle-notch fa-spin mr-2"></i><span class="fa fa-envelope nav-icon"></span><span v-show="$bus.messagingCenter.unread" class="nav-item-cart-count">{{$bus.messagingCenter.unread}}</span>
          </a>
        </li>

        <li class="nav-item pr-0" v-if="authenticated && showShoppingCart">
          <a @click.prevent="handleRoute('cart')" class="nav-item-cart" href="/app/cart">
            <span class="fa fa-shopping-cart nav-icon"></span><span v-show="$bus.shoppingCart.count" class="nav-item-cart-count">{{$bus.shoppingCart.count}}</span>
          </a>
        </li>
        <template v-if="!authenticated">
          <li class="nav-item p-0 ml-4">
            <a id="dnn_dnnLogin_loginLink" title="Login" rel="nofollow" :href="loginUrl" class="btn btn-primary btn-md _sass-login-btn">Login</a>
          </li>
          <template v-if="tenant && tenant.metadata && tenant.metadata.menuRight && tenant.metadata.menuRight.unauthenticated">
            <li v-for="pin in tenant.metadata.menuRight.unauthenticated" v-if="hasSkinPermission(pin)" class="nav-item p-0 ml-2">
              <menu-item :item="pin" :iframe="iframe" css-override="btn btn-primary btn-md _sass-login-btn" :border="false" />
            </li>
          </template>
        </template>
        <template v-else>

          <li class="nav-item dropdown d-none d-xl-block" v-if="taskList.length">
            <a class="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div class="position-relative">
                <span class="fa fa-tasks nav-icon suser-nav"></span>
                <span class="badge badge-danger badge-round rounded-pill position-absolute" style="top: -5px;right: -10px;height: 20px;width: 20px;text-align: center;">{{taskList.length}}</span>
              </div>
            </a>
            <div class="dropdown-menu dropdown-menu-right pl-3 pr-3" style="max-height: 50vh; overflow-y: auto; width: max-content">
              <table class="table table-small small">
                <tr v-for="task in taskList" v-bind:key="task.key" class="border-0">
                  <td class="align-middle border-0 pt-1 pb-1">
                    <a v-if="['Orders', 'Workspace-Orders'].includes(task.list)" :href="'/app/orders/' + task.guid" style="font-size: 12px">{{task.number}}</a>
                    <a v-else-if="task.list === 'Approval-Requests'" :href="'/app/approval-request/' + task.guid" style="font-size: 12px">{{task.number}}</a>
                    <span v-else style="font-size: 12px">{{task.number}}</span>
                  </td>
                  <td class="align-middle border-0 pt-1 pb-1"><span class="ml-3 mr-3">{{task.listDisplay}}</span></td>
                  <td class="align-middle text-right pt-1 pb-1 border-0">
                    <div role="alert" class="task-status w-100 _sass-conflict dbp-status-badge el-alert is-light generic warning">
                      <svg width="13px" height="13px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g fill="#D68601" class="icon-alerts warning fill">
                            <path d="M9,13 L11,13 L11,15 L9,15 L9,13 Z M9,5 L11,5 L11,11 L9,11 L9,5 Z"></path>
                            <path d="M9.99,0 C4.47,0 0,4.48 0,10 C0,15.52 4.47,20 9.99,20 C15.52,20 20,15.52 20,10 C20,4.48 15.52,0 9.99,0 L9.99,0 Z M10,18 C5.58,18 2,14.42 2,10 C2,5.58 5.58,2 10,2 C14.42,2 18,5.58 18,10 C18,14.42 14.42,18 10,18 L10,18 Z"></path>
                          </g>
                        </g>
                      </svg>
                      <div class="el-alert__content"><span class="el-alert__title" style="line-height: 1.2;font-size: 12px;">{{task.status}}</span></div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </li>

          <li class="nav-item dropdown d-none d-xl-block">
            <a class="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="fa fa-user nav-icon user-nav"></span> <span v-if="navUsername" class="position-relative ml-1" style="bottom: 2px">{{navUsername}}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-right text-left">
              <template v-if="showMyAccount">
                <a class="dropdown-item" :href="profileUrl">My Account</a>
                <div class="dropdown-divider"></div>
              </template>
              <a class="dropdown-item" :href="logoffUrl">Logout</a>
            </div>
          </li>

          <li class="nav-item d-block d-xl-none" v-if="showMyAccount">
            <a class="nav-link" :href="profileUrl">My Account</a>
          </li>



          <li class="nav-item d-block d-xl-none">
            <a class="nav-link" :href="logoffUrl">Logout</a>
          </li>

        </template>



      </template>

    </ul>


  </div>

</template>

<script>
    import MenuListItem from "./MenuListItem";
    import MenuItem from "./MenuItem";
    export default {
      name: 'Skin',

      props: {
        tenant: Object,
        authenticated: Boolean,
        isVerified: Boolean,
        loginUrl: String,
        logoffUrl: String,
        profileUrl: String,
        skinPermissions: Array,
        iframe: Boolean
      },

      components: {
        MenuListItem,
        MenuItem
      },

      mounted() {
        const navbar = document.getElementById("spa_header");
        const body = document.getElementById("Body");
        document.documentElement.style.setProperty(
          '--navbar-height',
          body?.classList?.contains("sticky-navbar") &&
            typeof navbar?.getBoundingClientRect === "function"
            ? `${navbar.getBoundingClientRect().height}px`
            : "0px"
        );
      },

      computed: {

        notifications() {
          return this.$bus.messagingCenter?.notifications ?? [];
        },

        taskList() {

          if (this.tenant?.metadata?.[this.tenant.configuration]?.navSettings?.taskList?.enabled) {
            if (Array.isArray(this.$bus?.tenant?.taskList)) {
              return this.$bus.tenant.taskList;
            }
          }
          return [];
        },

        showMyAccount() {
          return this.tenant?.metadata?.[this.tenant.configuration]?.navSettings?.displayMyAccount !== false;
        },


        showShoppingCart() {
          return Boolean(this.$bus.shoppingCart?.enabled);
        },

        showMessagingCenter() {
          return this.authenticated && this.isVerified && Boolean(this.$bus.messagingCenter?.enabled);
        },

        navUsername() {

          try {
            const profileDisplayMode = this.tenant?.metadata?.[this.tenant.configuration]?.navSettings?.userNameDisplayMode ?? null;

            if (!profileDisplayMode) {
              return null;
            }
            if (profileDisplayMode === "firstname") {
              return this.tenant.user?.firstName ?? null;
            }
            if (profileDisplayMode === "lastname") {
              return this.tenant.user?.lastName ?? null;
            }
            if (profileDisplayMode === "fullname") {
              return this.tenant.user?.fullName ?? null;
            }
            if (profileDisplayMode === "username") {
              return this.tenant.user?.username ?? null;
            }
            return profileDisplayMode;
          } catch (e) {
            console.warn(e);
            return null;
          }

        }
      },

      methods: {

        rerender() {
          this.$forceUpdate();
        },

        hasSkinPermission(pin) {

         try {

          if (typeof pin === "string") {
           return true;
          }

          if (Array.isArray(pin.env) && !pin.env.includes(this.tenant.configuration)) {
           return false;
          }

          if (pin.anonymous) {
           return true;
          }

          if (Array.isArray(pin.permissions) && pin.permissions.length > 0) {
           return pin.permissions.some((r) => this.skinPermissions.indexOf(r) > -1);
          }

          return this.authenticated && this.isVerified;

         } catch (e) {
          console.log("permission error", e);
          return false;
         }


        },



        handleRoute(route) {
          if (window.dbpvnext?.modules?.account) {
            this.$bus.$emit("route", { name: route });
          } else {
            window.location.href = "/app/" + route;
          }
        },

        onMessagingCenter() {
          this.$bus.$emit("messaging-center");
        }
      },


    };
</script>